module.exports = __webpack_public_path__ + "static/media/2-FALK.052da14b.mp3";